<template>
<div>
  <form @submit.prevent="submit">
    <b-row>
     
      <b-col sm="4">

         <label>Certificado Sanitizacion</label>
           <b-form-select
          v-model="waybillDataConditionTransportExport.sanitation_certificate"
          >
          <option value="Si">Si</option>
          <option value="No">No</option>
        </b-form-select>



          <label>Unid. de Frío antes de cargar</label>
           <b-form-select
          v-model="waybillDataConditionTransportExport.cold_unit_before_loading"
          >
          <option value="Encendida">Encendida</option>
          <option value="Apagada">Apagada</option>
        </b-form-select>


        <label>Limpieza Interior</label>
           <b-form-select
          v-model="waybillDataConditionTransportExport.interior_cleaning"
          >
          <option value="Buena">Buena</option>
          <option value="Regular">Regular</option>
          <option value="Mala">Mala</option>
        </b-form-select>



        <label>Canales Ventilación del piso</label>
           <b-form-select
          v-model="waybillDataConditionTransportExport.channels_floor_ventilation"
          >
          <option value="Buena">Buena</option>
          <option value="Regular">Regular</option>
          <option value="Mala">Mala</option>
        </b-form-select>

      

      </b-col>


      <b-col sm="4">

          <label>Sellado y Gomas de Puerta</label>
           <b-form-select
          v-model="waybillDataConditionTransportExport.sealing_and_door_rubber"
          >
          <option value="Buena">Buena</option>
          <option value="Regular">Regular</option>
          <option value="Mala">Mala</option>
        </b-form-select>


           <label>Drenes de líquidos tapados</label>
           <b-form-select
         v-model="waybillDataConditionTransportExport.drained_liquid_drains"
          >
          <option value="Si">Si</option>
          <option value="No">No</option>
        </b-form-select>


          <label>Carga bajo la linea roja</label>
           <b-form-select
         v-model="waybillDataConditionTransportExport.load_under_the_red_line"
          >
          <option value="Si">Si</option>
          <option value="No">No</option>
        </b-form-select>


        <label>Equipo Autónomo de energía</label>
           <b-form-select
         v-model="waybillDataConditionTransportExport.autonomous_energy_equipment"
          >
          <option value="Si">Si</option>
          <option value="No">No</option>
        </b-form-select>




      </b-col>



      <b-col sm="4">

        <label>T° Set Point</label>
           <b-form-select
           v-model="waybillDataConditionTransportExport.temperature_set_point"
          >
          <option value="Ventilación(CBM)">Ventilación(CBM)</option>
        </b-form-select>


             <label>Equipo Autónomo de energía</label>
           <b-form-select
         v-model="waybillDataConditionTransportExport.autonomous_energy_equipment"
          >
          <option value="Si">Si</option>
          <option value="No">No</option>
        </b-form-select>


          <label>Cortina de Atmósfera Controlada</label>
           <b-form-select
         v-model="waybillDataConditionTransportExport.controlled_atmosphere_curtain"
          >
          <option value="Si">Si</option>
          <option value="No">No</option>
        </b-form-select>


        <label>Sellado con cartones de piso y pallets</label>
           <b-form-select
         v-model="waybillDataConditionTransportExport.sealing_with_floorboard_and_pallets"
          >
          <option value="Si">Si</option>
          <option value="No">No</option>
        </b-form-select>

  

           

             


      </b-col>


       <b-col sm="6">

      

              <b-form-group label="Sello Naviera">
          <b-form-input
            type="text"
            v-model="waybillDataConditionTransportExport.shipping_stamp"
            placeholder="">
            </b-form-input>
            </b-form-group>


      </b-col>



      <b-col sm="6">

      

             <b-form-group label="Sello Planta">
          <b-form-input
            type="text"
            v-model="waybillDataConditionTransportExport.seal_plant"
            placeholder="">
            </b-form-input>
            </b-form-group>


      </b-col>





      
    </b-row>
  </form>
  </div>
</template>

<script>



  export default {
    name: "formCondicionTransporte",
    props: [
      'waybill_id',
      'waybillDataConditionTransportExport'
    ],
    data() {
      return {

      }
    },
    mounted () {
 
    },
    methods: {
      loadDataForm(){

           this.$axios.get('/api/comex/export_waybill/detailed_condition_transport_export/', {
            params: {
              waybill_id: this.waybill_id
            }
          })
            .then(res => {
          this.waybillDataConditionTransportExport.sanitation_certificate= res.data.data[0].sanitation_certificate;
          this.waybillDataConditionTransportExport.cold_unit_before_loading= res.data.data[0].cold_unit_before_loading;
          this.waybillDataConditionTransportExport.interior_cleaning= res.data.data[0].interior_cleaning;
          this.waybillDataConditionTransportExport.channels_floor_ventilation= res.data.data[0].channels_floor_ventilation;
          this.waybillDataConditionTransportExport.sealing_and_door_rubber= res.data.data[0].sealing_and_door_rubber;
          this.waybillDataConditionTransportExport.drained_liquid_drains= res.data.data[0].drained_liquid_drains;
          this.waybillDataConditionTransportExport.load_under_the_red_line= res.data.data[0].load_under_the_red_line;
          this.waybillDataConditionTransportExport.autonomous_energy_equipment= res.data.data[0].autonomous_energy_equipment;
          this.waybillDataConditionTransportExport.temperature_set_point= res.data.data[0].temperature_set_point;
          this.waybillDataConditionTransportExport.controlled_atmosphere_curtain= res.data.data[0].controlled_atmosphere_curtain;
          this.waybillDataConditionTransportExport.sealing_with_floorboard_and_pallets= res.data.data[0].sealing_with_floorboard_and_pallets;
          this.waybillDataConditionTransportExport.shipping_stamp= res.data.data[0].shipping_stamp;
          this.waybillDataConditionTransportExport.seal_plant= res.data.data[0].seal_plant;
            }).catch(error => {
                 
            });

      },
      submit() {
      },
    },
    beforeMount() {
      
    },
  }

</script>

<style scoped>

</style>
